<br>

<!--div class="form-row btntop col-sm-12" style="margin-top: 10px;">

  <table>
    <tr>
      <td>
        <button class="btn border" (click)="search()" [disabled]="!form.dirty">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="clear()">Rensa</button>
      </td>
    </tr>
  </table>
  <p class="reportlabel">Rapport: Närvaro per institution inom institutionens distrikt</p>
</div-->
<div class="form-row btntop col-sm-12 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
        <button class="btn border" [disabled]="!form.dirty" (click)="search()">Sök</button>
        <button class="btn border" (click)="clear()">Rensa</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: Närvaro per institution inom institutionens distrikt</p>

    </div>
  </div>
</div>

<div class="col-md-5 ms-4 me-4">


<form [formGroup]="form" (keydown.enter)="search()">
   <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="institutionId">Välj institution</label>
              <select class="form-control form-control-sm" id="value" formControlName="institutionId" required>
                <option></option>
                <option *ngFor="let i of institutionslist" [ngValue]="i.value">{{i.label}}</option>
              </select>
            </div>

            <div class="form-group">
              <label for="year">
                År
              </label>
              <input type="text" class="form-control form-control-sm" id="year" style="max-width:80px;" formControlName="year" required>
            </div>
          </div>

</form>

</div>

<br>
<div *ngIf="result.length > 0" class="col-md-8 ms-4">
  <p-menubar [model]="items">
    <div style="margin-top:5px;margin-right:10px;">
      Resultat: {{result?.length}}
  </div>
  </p-menubar>
  <table class="table border">
    <tr>
      <th>Besökare från inst</th>
      <th>År</th>
      <th>Antal besök</th>
      <th>Distrikt</th>
      <th>Besökt inst</th>
    </tr>
    <tr *ngFor="let r of result">
      <td>{{r.visitors}}</td>
      <td>{{r.year}}</td>
      <td>{{r.visitorsCount}}</td>
      <td>{{r.district}}</td>
      <td>{{r.visited}}</td>
    </tr>
    <tr>
      <td><b>Totalt:</b></td>
      <td></td>
      <td><b>{{total}}</b></td>
      <td></td>
      <td></td>
    </tr>

</table>
</div>


